<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            <validation-provider
              #default="{ errors }"
              name="evento"
              rules="required"
            >
              <b-form-group
                label="Evento"
                label-for="evento"
              >
                <v-select
                  id="evento"
                  v-model="eventField.evento"
                  data-cy="select-evento"
                  :options="eventos"
                  label="nome"
                  :reduce="(evento) => evento"
                  placeholder="Selecione o evento"
                  :disabled="!canEditOrInsert"
                >
                  <template #no-options>
                    <div class="text-muted">
                      Nenhum evento encontrado
                    </div>
                  </template>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            md="6"
          >
            <validation-provider
              #default="{ errors }"
              name="campo"
              rules="required"
            >
              <b-form-group
                label="Campo"
                label-for="campo"
              >
                <v-select
                  id="campo"
                  v-model="eventField.campo"
                  data-cy="select-campo"
                  :options="campos"
                  label="nome"
                  :reduce="(reg) => reg"
                  placeholder="Selecione o campo"
                  :disabled="!canEditOrInsert"
                >
                  <template #no-options>
                    <div class="text-muted">
                      Nenhum campo encontrado
                    </div>
                  </template>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="valor"
              rules="required"
            >
              <b-form-group
                label="Valor"
                label-for="valor"
              >
                <b-form-input
                  id="valor"
                  v-model="eventField.valor"
                  data-cy="input-valor"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Digite o valor"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="error-valor"
                  class="text-danger"
                >{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <b-form-checkbox
              v-model="eventField.ativo"
              data-cy="switch-ativo"
              name="ativo"
              switch
              :disabled="!canEditOrInsert"
            >
              {{ eventField.ativo ? "Sim" : "Não" }}
            </b-form-checkbox>
          </b-col>

          <ButtonsFormVue
            :permission-insert="verificarPermissao('ROLE_EVENTOS_INSERIR')"
            :permission-edit="verificarPermissao('ROLE_EVENTOS_ATUALIZAR')"
            :disable-form="false"
            @save="save"
            @cancel="cancel"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BCard,
  BForm,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import { verificarPermissao } from '@/auth/utils'

export default {
  name: 'EventFieldForm',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BCard,
    BForm,
    vSelect,
    ButtonsFormVue,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      verificarPermissao,
      titleForm: 'Cadastro de Campos de Evento',
      required,
      eventos: [],
      campos: [],
    }
  },
  computed: {
    ...mapState('eventFieldSettingsModule', {
      eventField: state => state.eventField,
    }),
    canEditOrInsert() {
      return (
        (!this.eventField.id
          && this.verificarPermissao('ROLE_EVENTOS_INSERIR'))
        || (this.eventField.id
          && this.verificarPermissao('ROLE_EVENTOS_ATUALIZAR'))
      )
    },
  },
  created() {
    this.loadDependencies()
  },
  methods: {
    async loadDependencies() {
      try {
        const queryParams = {
          page: 1, size: 1000, sort: 'nome', order: 'asc',
        }

        // Load Events
        this.$store.dispatch('eventSettingsModule/loadTable', queryParams)
          .then(result => {
            this.eventos = result.data.content
          })

        // Load Fields (Tipo Evento Campos)
        this.$store.dispatch('eventTypeFieldSettingsModule/loadTable', { ...queryParams, sort: 'id' })
          .then(result => {
            this.campos = result.data.content
          })
      } catch (error) {
        console.error('Error loading dependencies:', error)
      }
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          const payload = {
            ...this.eventField,
            evento: { id: this.eventField.evento?.id },
            campo: { id: this.eventField.campo?.id },
          }

          const action = this.eventField.id ? 'edit' : 'insertNew'
          this.$store
            .dispatch(`eventFieldSettingsModule/${action}`, payload)
            .then(response => {
              if (response.response) {
                this.MensagemError(
                  this.eventField.id ? 'Falha ao Editar' : 'Falha ao Inserir',
                  response.response.data.error,
                )
                return
              }
              this.showMessageSuccess(
                this.eventField.id ? 'Editar' : 'Salvo',
                this.eventField.id
                  ? 'Editado com sucesso!'
                  : 'Incluído com sucesso!',
              )
              this.cancel()
            })
        }
      })
    },
    cancel() {
      this.$emit('cancelar')
      this.$store.dispatch('eventFieldSettingsModule/reset')
    },
  },
}
</script>
